import { DialogActions } from '@mui/material';

import { Button } from '../../Button/Button';
import type { DialogButton, DialogSaveButton } from '../types';

export type TypeDialogButtons = {
  /**
   * @prop {string} id - id of the entry, used to create testId
   */
  id: string;

  /**
   * @prop {boolean} open - if true, start the countdown
   * @default true
   */
  open?: boolean;

  /**
   * @prop {DialogButton} cancelButton - definition of the cancel button
   */
  cancelButton?: DialogButton;

  /**
   * @props {DialogSaveButton} saveButton - definition of the save button
   */
  saveButton?: DialogSaveButton;
};

export const DialogButtons = ({ id, open = true, cancelButton, saveButton }: TypeDialogButtons) => {
  return (
    <DialogActions data-testid={`dialog-${id}-actions`}>
      {cancelButton && (
        <Button
          size="medium"
          id={`dialog-${id}-cancel-button`}
          disabled={cancelButton.disabled}
          btnType={cancelButton.color ? cancelButton.color : 'text'}
          displayLabel={cancelButton.label ? cancelButton.label : 'Cancel'}
          onClickHandler={() => cancelButton.onClick && cancelButton.onClick()}
        />
      )}
      {saveButton && (
        <Button
          size="medium"
          id={`dialog-${id}-save-button`}
          disabled={saveButton.disabled}
          waitButton={saveButton.wait}
          countdownButton={saveButton.countdown}
          countdownTime={saveButton.countdownTime}
          countdownStart={open}
          btnType={saveButton.color}
          onClickHandler={() => saveButton.onClick && saveButton.onClick()}
          displayLabel={saveButton.label ? saveButton.label : 'Save'}
          startIcon={saveButton.startIcon}
        />
      )}
    </DialogActions>
  );
};
